import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
const getNoOfRevisions = (data, fieldKey) => {
  const maxRevisions = data?.reduce(
    (max, item) => Math.max(max, item.revision.length),
    0
  );
  const columns = [];
  for (let i = 1; i <= maxRevisions; i++) {
    let suffix = "th";
    if (i === 1) {
      suffix = "st";
    } else if (i === 2) {
      suffix = "nd";
    } else if (i === 3) {
      suffix = "rd";
    }
    columns.push({
      label: `${i}${suffix}`,
      id: `${fieldKey}`,
      render: (data) => {
        const revisionField = data?.revision?.[i - 1]?.[fieldKey] || "-";
        return <span>{revisionField}</span>;
      },
    });
  }
  if (columns.length) {
    return columns;
  } else {
    return ["-"];
  }
};
export const HeaderConfig = (data) => {
  const result = [
    {
      label: "SI. No.",
      id: "sNo",
    },
    {
      label: "Engine Model",
      id: "engineModel",
    },
    {
      label: "List Number",
      id: "listNumber",
    },
    {
      label: "Version",
      id: "versionNumber",
    },
    {
      label: "released On",
      id: "releasedOn",
      render: (data) => {
        return moment(data.releasedOn).format("DD-MM-YYYY");
      },
    },
    {
      label: "Remarks",
      id: "remarks",
    },
    {
      label: "Action",
      id: "action",
      render: (data, onClick) => (
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={() => onClick("DOWNLOAD", data)}>
            <Icon
              icon="tabler:download"
              width="1.5rem"
              height="1.5rem"
              style={{ color: "#095adc" }}
            />
          </IconButton>
          <IconButton onClick={() => onClick("EDIT", data)}>
            <EditIcon color="primary" />
          </IconButton>
          <IconButton>
            <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
          </IconButton>
        </Box>
      ),
    },
    // {
    //   label: "Revision",
    //   id: "revision",
    //   columns: getNoOfRevisions(data, "versionNumber"),
    // },
    // {
    //   label: "Remarks for revision",
    //   id: "revisionRemarks",
    //   columns: getNoOfRevisions(data, "remarks"),
    // },
  ];

  return result;
};

export const getWsmFormConfig = (oems = []) => [
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Enter engine model",
    required: true,
  },
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Organisation",
    options: oems,
    required: true,
  },
  {
    name: "versionNumber",
    type: "text",
    label: "WSM Version",
    placeholder: "Enter Version",
    required: true,
  },
  {
    name: "listNumber",
    type: "text",
    label: "List Number",
    placeholder: "Enter List Number",
    required: true,
  },
  {
    name: "releasedOn",
    type: "datePicker",
    label: "Released On",
    placeholder: "Release Date",
    required: true,
  },
  {
    label: "Remarks",
    name: "remarks",
    placeholder: "Remarks for version change",
    type: "textarea",
    required: true,
    fieldGridSize: 12,
  },
];
